import { render } from "./VideoTutorialModal.vue?vue&type=template&id=49daacdd&scoped=true"
import script from "./VideoTutorialModal.vue?vue&type=script&lang=js"
export * from "./VideoTutorialModal.vue?vue&type=script&lang=js"

import "./VideoTutorialModal.vue?vue&type=style&index=0&id=49daacdd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49daacdd"]])

export default __exports__